import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextInput from 'components/form/TextInput';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

const StickyBanner = ({ id, banner, onInputChange, onRadioChange }) => {
  const [t] = useTranslation('groups');
  const { enabled, buttonText, desc, position } = banner;
  const isEnabled = Boolean(enabled);
  return (
    <Box>
      <Typography fontWeight={500}>
        {t('cc-from-sticky-title', 'Add a Sticky Banner')}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        {t(
          'cc-form-sticky-desc',
          'This will display a header bar at the top or bottom of your website.',
        )}
      </Typography>
      {isEnabled && (
        <React.Fragment>
          <TextInput
            fullWidth
            inputProps={{
              multiLine: true,
              rows: 4,
            }}
            name="collection_settings.banner.desc"
            value={desc}
            onChange={onInputChange}
            placeholder={t(
              'cc-form-sticky-desc-placeholder',
              'Ex. Preregister your kids and we’ll make sure our staff is ready.',
            )}
          />
          <Typography gutterBottom sx={{ mt: 1 }} fontWeight={500}>
            Banner Position
          </Typography>
          <ToggleButtonGroup
            exclusive
            size="small"
            color="primary"
            fullWidth
            onChange={(e, value) =>
              value &&
              onInputChange({
                target: {
                  name: 'collection_settings.banner.position',
                  value,
                },
              })
            }
            value={position}
          >
            <ToggleButton value="top">
              {t('cc-form-sticky-position-top', 'Top of Site')}
            </ToggleButton>
            <ToggleButton value="bottom">
              {t('cc-form-sticky-position-bottom', 'Bottom of Site')}
            </ToggleButton>
          </ToggleButtonGroup>
          <TextInput
            fullWidth
            name="collection_settings.banner.buttonText"
            label={t('cc-form-sticky-button', 'Custom Button Text')}
            placeholder="OK!"
            value={buttonText}
            onChange={onInputChange}
          />
        </React.Fragment>
      )}
    </Box>
  );
};

export default StickyBanner;
